// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filepond--wrapper {
    flex: 1;
}

.filepond--credits {
    display: none;
}

.filepond-custom {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.filepond--root {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.filepond--drop-label {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/main/frontend/pages/embedding/embedding.css"],"names":[],"mappings":"AAAA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".filepond--wrapper {\n    flex: 1;\n}\n\n.filepond--credits {\n    display: none;\n}\n\n.filepond-custom {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.filepond--root {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.filepond--drop-label {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
